<template>
    <card-grid
        v-if="data && data.projects && data.projects.length"
        cardType="project"
        :cards="data.projects"
    />
</template>

<script>
import CardGrid from 'components/CardGrid'

import Tag from 'objects/Tag'

import { SECTION_HANDLES } from 'src/constants'

import { excerpt } from 'src/utils'

export default {
    name: 'BlockProjectsList',
    components: {
        CardGrid,
        Tag
    },
    data: () => ({
        SECTION_HANDLES,
    }),
    props: {
        data: false,
    },
    methods: {
        excerpt
    }
}
</script>

<style lang="scss">
.b-projects-list {
}
</style>
